/* eslint-disable react/no-danger */
import { Link } from 'gatsby';
import _ from 'lodash';
import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function FreeZoneConventionTower({ data, id }) {
  const { title, text, image, video, link } = data;
  return (
    <section
      id={id}
      className="pt-[50px] lg:pt-[80px] xl:pt-[136px] pb-[38px] lg:pb-20
    bg-[#f7f7f7] md:bg-[#F2F2F2]">
      <div className="max-w-[1752px] px-4 mx-auto relative">
        <div
          className="flex flex-col md:flex-row lg:justify-between gap-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5 }}
            viewport={{ once: true }}
            className="hidden lg:block lg:w-[31.69%] pt-8 xl:pt-16">
            <div className="relative">
              {_.isEmpty(image) || (
                <LazyLoadImage
                  src={image.url}
                  alt="Convention Tower 2"
                  width="100%"
                  effect="blur"
                  wrapperClassName="!hidden lg:!block h-auto 
                  overflow-hidden relative z-10 
                  ltr:mr-0 ltr:ml-auto rtl:ml-0 rtl:mr-auto"
                  className="ltr:mr-0 ltr:ml-auto rtl:ml-0 rtl:mr-auto md:h-auto object-cover
                  md:aspect-[545/413] w-full"
                />
              )}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="md:w-1/2 lg:w-[34.26%] flex flex-col gap-y-5 lg:gap-y-10 md:pt-8 xl:pt-15 
            ltr:lg:pl-10 ltr:2xl:pl-20 ltr:pr-6
            rtl:lg:pr-10 rtl:2xl:pr-20 rtl:pl-6
            ">
            <div className="flex flex-col gap-y-5 lg:gap-y-7">
              <div
                dangerouslySetInnerHTML={{ __html: title }}
                className="text-clamp20to40  h2-child:text-clamp20to40 text-[#000]
                h2-child:leading-1.2 h2-child:!m-0 ltr:md:text-left
                text-center rtl:md:text-right [&>h2>br]:hidden [&>h2>br]:md:inline-block"
              />
              <div className="h-[2px] w-[50px] md:w-[70px] bg-[#CE445B] mx-auto md:mx-0" />
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: text }}
              className="p-child:text-[#4A4A4A] p-child:text-clamp12to18 p-child:font-normal
                p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular 
                p-child:rtl:font-GESSTwoDWTCLight ltr:md:text-left
                text-center rtl:md:text-right"
            />
            {_.isEmpty(link) || (
              <div className="flex justify-center md:justify-start">
                <Link
                  href={link.url}
                  className="convention-tower-cta w-fit flex justify-center 
                    items-center rounded-[48px]
                    bg-[#CE445B] hover:bg-[#B53B50] text-white uppercase 
                    font-URWDINBold ltr:tracking-[0.96px] leading-1.5 md:leading-1.25
                    min-h-10 md:h-[51px] text-center px-12 md:px-14 py-2
                    rtl:text-[12px] ltr:text-[11px] rtl:md:text-[16px] ltr:md:text-[15px] 
                    rtl:lg:text-[18px] md:py-5 rtl:pt-[10px] ltr:pt-[12px] 
                    ltr:md:pt-6 rtl:md:pt-5 ">
                  {link.name}
                </Link>
              </div>
            )}
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="w-[31.68%] hidden lg:block">
            {_.isEmpty(video) || (
              <video
                src={video}
                muted
                autoPlay
                loop
                playsInline
                preload=""
                className="w-full object-cover object-top h-auto 
                aspect-[176/127] lg:aspect-[545/550]"
              />
            )}
          </motion.div>
          
          <div className='lg:hidden md:w-1/2 pt-5'>
            <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            className="w-[54%] md:w-[32%] absolute ltr:right-10 rtl:left-10 z-10 lg:static">
            {_.isEmpty(video) || (
              <video
                src={video}
                muted
                autoPlay
                loop
                playsInline
                preload=""
                className="w-full object-cover object-top h-auto 
                aspect-[176/127] lg:aspect-[545/550]"
              />
            )}
          </motion.div>
          
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 0.6 }}
              viewport={{ once: true }}
              className="relative z-0 pt-[30%]">
                {_.isEmpty(image) || (
                  <LazyLoadImage
                    src={image.url}
                    alt="Convention Tower 2"
                    width="100%"
                    effect="blur"
                    className="ltr:mr-0 ltr:ml-auto rtl:ml-0 rtl:mr-auto md:h-auto object-cover
                    md:aspect-[545/413] w-full"
                  />
                )}
              </motion.div>
            </div>
        </div>
      </div>
    </section>
  );
}
